import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

const selectCredentialState = createSelector(
  (state: RootState) => state.credentials,
  (credentials) => credentials
);

export default selectCredentialState;
